import React from 'react';
import CareerChavdiSection from '../components/CareerChavdiSection';

const CareerChavdiPage = () => {
    return (
        <div className="bg-slate-50 min-h-[85vh] font-poppins">
            <CareerChavdiSection customPadding="pb-12 lg:pb-24 pt-4 lg:pt-8" hideSubtitle={true} isStandalone={true} />
        </div>
    );
};

export default CareerChavdiPage;
